import { $tag, TaggedEnumUnion, extendEnum, tagEnum } from '@suntex.core/types';

import { buildStaticContext } from '../utils';

import { GradeLevel } from './grade-level';

const $ = 'SpecialGradeLevel';

export const SpecialGradeLevel = {
  Null: tagEnum($, -9999),
  AllGrades: tagEnum($, 100),
  Unassigned: tagEnum($, -1),
  Grade1: extendEnum($, GradeLevel.Level1),
  Grade2: extendEnum($, GradeLevel.Level2),
  Grade3: extendEnum($, GradeLevel.Level3),
  Grade4: extendEnum($, GradeLevel.Level4),
  Grade5: extendEnum($, GradeLevel.Level5),
  Grade6: extendEnum($, GradeLevel.Level6),
  Grade7: extendEnum($, GradeLevel.Level7),
  Grade8: extendEnum($, GradeLevel.Level8),
  Grade9: tagEnum($, 9),
  Grade10: tagEnum($, 10),
  Other: tagEnum($, 50),
  Grade11: tagEnum($, 11),
  Grade12: tagEnum($, 12),
  Grades3To8: tagEnum($, 108),
  Kindergarten: extendEnum($, GradeLevel.LevelK),
  Top10Teachers: tagEnum($, 109),
  Top10FamilyLink: tagEnum($, 110),
  Top100Students: tagEnum($, 111),
  Top200Students: tagEnum($, 112),
  Top500Students: tagEnum($, 113),
  Top100StudentsUpTo200: tagEnum($, 115),
} as const;

export type SpecialGradeLevel = TaggedEnumUnion<typeof SpecialGradeLevel>;

export const $SpecialGradeLevel = buildStaticContext({
  [$tag]: $,
  [SpecialGradeLevel.Null]: {
    value: SpecialGradeLevel.Null,
    slug: 'null',
    label: 'Null',
  },
  [SpecialGradeLevel.AllGrades]: {
    value: SpecialGradeLevel.AllGrades,
    slug: 'all-grades',
    label: 'All Grades',
  },
  [SpecialGradeLevel.Unassigned]: {
    value: SpecialGradeLevel.Unassigned,
    slug: 'unassigned',
    label: 'Unassigned',
  },
  [SpecialGradeLevel.Grade1]: {
    value: SpecialGradeLevel.Grade1,
    slug: 'grade-1',
    label: 'Grade 1',
  },
  [SpecialGradeLevel.Grade2]: {
    value: SpecialGradeLevel.Grade2,
    slug: 'grade-2',
    label: 'Grade 2',
  },
  [SpecialGradeLevel.Grade3]: {
    value: SpecialGradeLevel.Grade3,
    slug: 'grade-3',
    label: 'Grade 3',
  },
  [SpecialGradeLevel.Grade4]: {
    value: SpecialGradeLevel.Grade4,
    slug: 'grade-4',
    label: 'Grade 4',
  },
  [SpecialGradeLevel.Grade5]: {
    value: SpecialGradeLevel.Grade5,
    slug: 'grade-5',
    label: 'Grade 5',
  },
  [SpecialGradeLevel.Grade6]: {
    value: SpecialGradeLevel.Grade6,
    slug: 'grade-6',
    label: 'Grade 6',
  },
  [SpecialGradeLevel.Grade7]: {
    value: SpecialGradeLevel.Grade7,
    slug: 'grade-7',
    label: 'Grade 7',
  },
  [SpecialGradeLevel.Grade8]: {
    value: SpecialGradeLevel.Grade8,
    slug: 'grade-8',
    label: 'Grade 8',
  },
  [SpecialGradeLevel.Grade9]: {
    value: SpecialGradeLevel.Grade9,
    slug: 'grade-9',
    label: 'Grade 9',
  },
  [SpecialGradeLevel.Grade10]: {
    value: SpecialGradeLevel.Grade10,
    slug: 'grade-10',
    label: 'Grade 10',
  },
  [SpecialGradeLevel.Other]: {
    value: SpecialGradeLevel.Other,
    slug: 'other',
    label: 'Other',
  },
  [SpecialGradeLevel.Grade11]: {
    value: SpecialGradeLevel.Grade11,
    slug: 'grade-11',
    label: 'Grade 11',
  },
  [SpecialGradeLevel.Grade12]: {
    value: SpecialGradeLevel.Grade12,
    slug: 'grade-12',
    label: 'Grade 12',
  },
  [SpecialGradeLevel.Grades3To8]: {
    value: SpecialGradeLevel.Grades3To8,
    slug: 'grades-3-to-8',
    label: 'Grades 3 to 8',
  },
  [SpecialGradeLevel.Kindergarten]: {
    value: SpecialGradeLevel.Kindergarten,
    slug: 'kindergarten',
    label: 'Kindergarten',
  },
  [SpecialGradeLevel.Top10Teachers]: {
    value: SpecialGradeLevel.Top10Teachers,
    slug: 'top-10-teachers',
    label: 'Top 10 Teachers',
  },
  [SpecialGradeLevel.Top10FamilyLink]: {
    value: SpecialGradeLevel.Top10FamilyLink,
    slug: 'top-10-family-link',
    label: 'Top 10 Family Link',
  },
  [SpecialGradeLevel.Top100Students]: {
    value: SpecialGradeLevel.Top100Students,
    slug: 'top-100-students',
    label: 'Top 100 Students, All Grades',
  },
  [SpecialGradeLevel.Top200Students]: {
    value: SpecialGradeLevel.Top200Students,
    slug: 'top-200-students',
    label: 'Top 200 Students, All Grades',
  },
  [SpecialGradeLevel.Top500Students]: {
    value: SpecialGradeLevel.Top500Students,
    slug: 'top-500-students',
    label: 'Top 500 Students, All Grades',
  },
  [SpecialGradeLevel.Top100StudentsUpTo200]: {
    value: SpecialGradeLevel.Top100StudentsUpTo200,
    slug: 'top-100-students-up-to-200',
    label: 'Top 100 Students Up To 200, Small Schools',
  },
} as const);
